import { axios } from '@repo/http';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orgProjectList } from './organization-project-list';
/**
 * PATCH restore project. Restores a deleted project and invalidates the organization project list cache.
 *
 * @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md
 */ export function useRestoreProject(param) {
    let { organization, queryParams } = param;
    const queryClient = useQueryClient();
    const queryKey = orgProjectList.projectList({
        organization,
        queryParams
    }).queryKey;
    return useMutation({
        mutationFn: (projectId)=>axios.post("/v2/project/".concat(projectId, "/restore")).catch((error)=>error),
        onSettled: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
